module.exports = __webpack_public_path__ + "static/media/boxes.5b2274cc.png";